import PropTypes from "prop-types";
import React, { Component } from "react";
import Clipboard from "react-copy-to-clipboard";
import { timer } from "../../utils/timer";
import Input from "./Input";
import { Container } from "./styled/input-copy";

class InputCopy extends Component {
  state = {
    copied: false
  };

  render() {
    return (
      <Container>
        <Input id={this.props.id} value={this.props.value} readOnly />
        <Clipboard text={this.props.value} onCopy={this.handleOnCopy}>
          <button className="helix-btn helix-btn--primary">
            {this.state.copied ? this.props.copiedText : this.props.copyText}
          </button>
        </Clipboard>
      </Container>
    );
  }

  componentDidUpdate(_, prevState) {
    if (!prevState.copied && this.state.copied) {
      this.setLabel();
    }
  }

  handleOnCopy = () => {
    this.setState({ copied: true });
  };

  setLabel = async () => {
    await timer(this.props.copyTextDelay);

    this.setState({ copied: false });
  };
}

InputCopy.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string.isRequired,
  copyText: PropTypes.string.isRequired,
  copiedText: PropTypes.string.isRequired,
  copyTextDelay: PropTypes.number.isRequired
};

InputCopy.defaultProps = {
  copyText: "Copy",
  copiedText: "Copied!",
  copyTextDelay: 2000
};

export default InputCopy;
